import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FAQService } from '@box-core/services/faq.service';
import { FAQCategory, SeoOptions } from '@box-types';
import { LoaderService, SEOService } from '@box-core/services';
import { finalize } from 'rxjs/operators';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BoxInfoDialogComponent } from '@box-shared/components';
import { deleteJsonLd } from '@box/utils';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'account-useful-links-faq',
  templateUrl: './account-useful-links-faq.page.html',
  styleUrls: ['./account-useful-links-faq.page.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountUsefulLinksFAQPage implements OnInit, OnDestroy {
  public faqCategories: FAQCategory[];
  public faqCategoryTitles: string[];
  public activeCategory: FAQCategory;
  public activeCategoryIndex: number;

  constructor(
    private faqService: FAQService,
    private loaderService: LoaderService,
    private dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private seoService: SEOService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getFAQ();
    this.setMetaTags();
  }

  ngOnDestroy(): void {
    deleteJsonLd();
  }

  public onSelectCategory(index: number): void {
    this.activeCategoryIndex = index;
    this.activeCategory = this.faqCategories[index];
  }

  private showFAQErrorDialog(): void {
    const dialogConfig: MatDialogConfig = {
      autoFocus: false,
      restoreFocus: false,
      ariaLabel: 'something_went_wrong',
      data: {
        title: 'something_went_wrong',
        messages: ['the_page_is_currently_unavailable', 'please_try_again_later']
      }
    };

    this.dialog.open(BoxInfoDialogComponent, dialogConfig);
  }

  private getFAQ(): void {
    this.loaderService.setState(true);
    this.changeDetectorRef.detectChanges();
    this.faqService
      .fetchFAQ$()
      .pipe(
        finalize(() => {
          this.loaderService.setState(false);
          this.changeDetectorRef.detectChanges();
        })
      )
      .subscribe({
        next: (faq) => {
          this.faqCategories = faq;
          this.faqCategoryTitles = this.faqCategories.map((category) => category.title);
          this.activeCategoryIndex = 0;
          this.activeCategory = this.faqCategories[this.activeCategoryIndex];
        },
        error: () => this.showFAQErrorDialog()
      });
  }

  private setMetaTags(): void {
    const options: SeoOptions = { title: this.activatedRoute.snapshot.data.breadcrumbName, url: this.router.url };
    this.seoService.setTags(options);
  }
}
